import { isInsuredAmountBelowDefault } from './isInsuredAmountBelowDefault'

/**
 * True while an under-declared insured amount still blocks checkout -- the shopper has declared
 * less than the order-derived default and has not (yet, or no longer) acknowledged that risk.
 */
export const isInsuredAmountAcknowledgementGated = (
  insuredAmount?: number,
  gross?: number,
  hasAcknowledgedLowInsuredAmount?: boolean
): boolean => isInsuredAmountBelowDefault(insuredAmount, gross) && !hasAcknowledgedLowInsuredAmount
